import React from 'react';
import styles from './styles/Page.module.css';

export default function TermsEnglish() {
  return (
    <>
      <div className={styles.page}>
        <h1 className={styles.page_title}>PRIVACY POLICY</h1>
        <div className={styles.date}>Version dated: September 21th, 2023</div>

        <p>
          When you browse the Website or use the Services, OSTREON may collect and process your Personal Data.
        </p>

        <p>
          OSTREON places particular emphasis on respecting your privacy and protecting your Personal Data.
        </p>

        <p>
          Your Personal Data belongs to you and is processed by OSTREON in a transparent, confidential, and secure manner.
        </p>

        <p className={styles.title}>
          <strong>
            1. What is the purpose of this policy?
          </strong>
        </p>

        <p>
          This privacy policy (hereinafter the "Privacy Policy") aims to inform you about:
          <ul>
            <li>
              the methods of collection and the characteristics of the processing of your Personal Data implemented by OSTREON, in accordance with the regulations relating to the protection of Data, in particular the GDPR and the law n° 78-17 of January 6, 1978 relating to data processing, files and freedoms amended and its implementing texts, as well as any legislative act and/or regulatory provision of French or European law applicable in France relating to the protection of Personal Data (hereinafter the "Regulation applicable to the protection of Personal Data");
            </li>
            <li>
              your rights with respect to the Regulation applicable to the protection of Personal Data.
            </li>
          </ul>
        </p>

        <p>
          The Privacy Policy is an integral part of the <a href="https://ostreon.io/terms-and-conditions">Terms and Conditions</a> and must be read in conjunction with them and applies to all personal information and browsing data collected and processed when you come into contact with OSTREON. All terms used with a capital letter and which are not defined in the Privacy Policy have the meaning given to them in the Terms and Conditions.
        </p>

        <p>
          OSTREON may modify the Privacy Policy at any time, in particular to ensure its compliance with legislative and regulatory changes. Information and/or a request for acceptance will therefore be communicated to the User if necessary via the website.
        </p>

        <p className={styles.title}>
          <strong>
            2. Who is responsible for processing?
          </strong>
        </p>

        <p>
          The Personal Data collected through the Site are processed by OSTREON, as the data controller:
        </p>

        <p className={styles.text_center}>
          <strong>
            OSTREON CYBERSECURITY
          </strong>
          <div>
            Simplified joint-stock company
          </div>

          <div>
            Registered with the RCS of Nanterre under registered number 920 541 448
          </div>

          <div>
            Head office located at 13 T rue Auguste Gervais – 92130 Issy-les-Moulineaux, France
          </div>
        </p>

        <p>
          For any questions regarding the management and use of your Personal Data, you can send an email to OSTREON at the following address: <a href="mailto:compliance@ostreon.io">compliance@ostreon.io</a>
        </p>

        <p className={styles.title}>
          <strong>
            3. What Personal Data is collected and processed by OSTREON?
          </strong>
        </p>

        <p>
          The following categories of Personal Data may be collected directly and processed by OSTREON:
        </p>

        <table className={styles.personal_table}>
          <tbody>
            <tr>
              <td>
                <strong>
                Users
                </strong>
              </td>
              <td>
                <div>
                  Identification data: first name, last name;
                </div>
                <div>
                  Contact data: e-mail;
                </div>
                <div>
                  Connection data: IP address, connection logs;
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <strong>
                Subscribed Customers
                </strong>
              </td>
              <td>
                <div>
                  Identification data: first name, last name;
                </div>
                <div>
                  Contact data: e-mail, postal address (billing data);
                </div>
                <div>
                  Economic and financial information (excluding Trial Offers): date and time of payment, amount, payment method, subscription plan, payment status, billing information;
                </div>
                <div>
                  Connection data: IP address, connection logs;
                </div>
                <div>
                  Management data: history, claims, requests, support messages.
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <p>
          The following categories of Personal Data may be indirectly collected and processed by OSTREON:
        </p>

        <table className={styles.personal_table}>
          <tbody>
            <tr>
              <td>
                <strong>
                Trusted Advisors (including the notary/lawyer)
                </strong>
              </td>
              <td>
                <div>
                  Identification data: surname, first name;
                </div>
                <div>
                  Contact data: email, postal address, phone number.
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <strong>
                Beneficiaries
                </strong>
              </td>
              <td>
                <div>
                  Identification data: surname, first name, birthday;
                </div>
                <div>
                  Contact data: email, phone number;
                </div>
                <div>
                  Connection data: IP address, connection logs;
                </div>
                <div>
                  Management data: history, complaints, requests, support messages.
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <p className={styles.title}>
          <strong>
            4. Why are your Personal Data collected and processed?
          </strong>
        </p>

        <p>
        Your Personal Data collected and processed by OSTREON are used for:
        <ul>
          <li>
          Management of the contractual relationship, which includes: management of the User Account; provision of the Services; prevention of non-payments; billing, collection, and dispute management; handling of complaints and requests;
          </li>
          <li>
          Management of relations with the Beneficiaries;
          </li>
          <li>
          Management and response to requests for the exercise of rights by the concerned individuals;
          </li>
          <li>
          Sending newsletters, commercial content, and advertising;
          </li>
          <li>
          Commercial prospecting;
          </li>
          <li>
          Management and enhancement of the website and its functionalities.
          </li>
        </ul>
        </p>

        <p className={styles.title}>
          <strong>
            5. On what legal grounds are the Personal Data of Users processed?
          </strong>
        </p>

        <p>
        The processes implemented by OSTREON are based on the following legal grounds:
        </p>

        <table className={`${styles.personal_table} ${styles.half_width}`}>
          <tbody>
            <tr>
              <td>
                <strong>
                Management of the contractual relationship
                </strong>
              </td>
              <td>
                <div>
                Execution of a contract
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <strong>
                Management and response to requests for the exercise of rights by the concerned individuals
                </strong>
              </td>
              <td>
                <div>
                Legal obligation
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <strong>
                Management of Beneficiaries
                </strong>
              </td>
              <td rowspan="4">
              OSTREON's legitimate interest
              </td>
            </tr>

            <tr>
              <td>
                <strong>
                Sending of newsletters
                </strong>
              </td>
            </tr>

            <tr>
              <td>
                <strong>
                Commercial prospecting
                </strong>
              </td>
            </tr>

            <tr>
              <td>
                <strong>
                Management and enhancement of the website and its functionalities
                </strong>
              </td>
            </tr>
          </tbody>
        </table>

        <p className={styles.title}>
          <strong>
            6. To whom may your Personal Data be disclosed?
          </strong>
        </p>

        <p>
        Your Personal Data is intended for use within OSTREON and its collaborators, partners, or service providers.
        </p>

        <p>
        OSTREON utilizes the following providers:
        <ul>
          <li>
          Stripe: for billing management;
          </li>
          <li>
          Google: For the usage of website and commercial performance and statistics, using Google Analytics tool and Google Ads.
          </li>
        </ul>
        </p>

        <p>
        Your Personal Data may not be sold or leased to third parties.
        </p>

        <p>
        OSTREON may disclose some of the Personal Data of Users upon request from legally authorized judicial, police, or administrative authorities.
        </p>

        <p className={styles.title}>
          <strong>
            7. How long does OSTREON retain your Personal Data?
          </strong>
        </p>

        <p>
        OSTREON retains Users' Personal Data for a duration that is strictly necessary and proportionate to the operations for which they were collected, including:
        </p>

        <table className={`${styles.personal_table} ${styles.half_width}`}>
          <tbody>
            <tr>
              <td>
                <strong>
                Management of the User Account
                </strong>
              </td>
              <td>
                <div>
                During the term of the contractual relationship or for the duration of the Customer Account
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <strong>
                Management of Beneficiaries
                </strong>
              </td>
              <td>
                
              </td>
            </tr>

            <tr>
              <td>
                <strong>
                Provision of Services
                </strong>
              </td>
              <td>
              During the term of the contractual relationship or for the duration of the Customer Account
              </td>
            </tr>

            <tr>
              <td>
                <strong>
                Commercial Prospecting
                </strong>
              </td>
              <td>
              Until the withdrawal of consent or three (3) years from the last contact of individuals with OSTREON
              </td>
            </tr>

            <tr>
              <td>
                <strong>
                Sending of Newsletters
                </strong>
              </td>
              <td>
              Until the withdrawal of consent
              </td>
            </tr>

            <tr>
              <td>
                <strong>
                Cookie preferences
                </strong>
              </td>
              <td>
              Six (6) months
              </td>
            </tr>
          </tbody>
        </table>

        <p>
        Subsequently, they are archived for a maximum period of five (5) years (excluding banking data and cookie preferences and subject to OSTREON's regulatory constraints), corresponding to the common law prescription period, in order to comply with the law, either anonymized or deleted, as appropriate.
        </p>


        <p className={styles.title}>
          <strong>
            8. What are your rights?
          </strong>
        </p>

        <p>
        Under the Applicable Data Protection Regulation, you have the following rights:
        <ul>
          <li>
          The right to access your Personal Data (Article 15 of the GDPR);
          </li>
          <li>
          The right to rectify your Personal Data (Article 16 GDPR);
          </li>
          <li>
          The right to request the deletion and limitation of your Personal Data (Article 17 of the GDPR);
          </li>
          <li>
          The right to portability of your Personal Data (Article 20 GDPR);
          </li>
          <li>
          The right to object to the processing of your Personal Data (Article 21 GDPR);
          </li>
          <li>
          The right to determine the terms of use, storage, and communication of your Personal Data after your death;
          </li>
          <li>
          The right to file a complaint with the competent supervisory authority, specifically the National Commission for Informatics and Liberties (CNIL).
          </li>
        </ul>
        </p>

        <p>
        You can exercise your rights by sending your request, explaining its purpose, by mail or email to the following addresses:
        <ul>
          <li>
          By email: <a href="mailto:compliance@ostreon.io">compliance@ostreon.io</a>;
          </li>
          <li>
          By post at the following postal address: 13 T rue Auguste Gervais – 92130 Issy-les-Moulineaux, France.
          </li>
        </ul>
        </p>

        <p className={styles.title}>
          <strong>
            9. What measures are implemented to protect your Personal Data?
          </strong>
        </p>

        <p>
        OSTREON implements the necessary technical and organizational measures to preserve the security and confidentiality of your Personal Data, including:
        <ul>
          <li>
          Zero trust and zero knowledge; except of the information detailed above, OSTREON avoids knowing or being capable of reading any other customer-related data, in particular the inheritance data and assets data – those are encrypted with the customer private key on their browser, sent and stored on OSTREON servers as encrypted unreadable data. OSTREON will never host the customer's private keys and can never read information encrypted with it;
          </li>
          <li>
          Separating servers for billing and inheritance data, to break the connection between customer identity that is required for billing, and customer's encrypted data related to their inheritance data;
          </li>
          <li>
          Securing the servers with different security measures provided by AWS, including anti-brute-force
          </li>
          <li>
          Implementing Google Captch v3;
          </li>
          <li>
          Protecting the admin panel in a restricted network;
          </li>
          <li>
          And more.
          </li>
        </ul>
        </p>

        <p className={styles.title}>
          <strong>
            10. Does the Website use cookies?
          </strong>
        </p>

        <p>
        Yes. Browsing the Website may cause the implementation of cookies on the user's computer. Cookies are small data text files that can be placed on the User's device when visiting a website, primarily to enhance the User experience.
        </p>

        <p className={styles.title}>
          <strong>
          Our Cookies Policy:
          </strong>
        </p>

        <p>
          We use cookies to enhance your browsing experience and security using OSTREON. By continuing to use OSTREON, you consent to the use of cookies in accordance with this Cookie Policy.
        </p>

        <p>
        At OSTREON, we want to assure you that we never collect any information that could help us identify you personally. We respect your privacy and strive to maintain a secure and anonymous browsing experience.
        </p>

        <p className={styles.title}>
          <strong>
            10.1. What are the aims of these Cookies?
          </strong>
        </p>

        <p>
          <strong>The Role of Cookies in Website Functionality and Information Provision:</strong>
          <div>
          Cookies are small text files that are stored on your device when you visit a website. They are widely used to make websites work more efficiently, as well as to provide information to the website owners.
          </div>
        </p>

        <p>
        We use the following types of cookies on the OSTREON website:
         </p>

        <p>
          <strong>
          Essential Cookies:
          </strong>
          These cookies are necessary for the functioning of the website and cannot be disabled in our systems. They are usually set in response to actions made by you, such as setting your privacy preferences, logging in, or filling out forms. You can set your browser to block or alert you about these cookies, but some parts of the website may not function properly.
        </p>

        <p>
          <strong>
          Analytical/Performance Cookies:
          </strong>
          These cookies allow us to analyze how visitors use OSTREON, so we can measure and improve its performance. They help us understand which pages are the most and least popular and see how visitors move around the site. All information collected by these cookies is aggregated and therefore anonymous. If you do not allow these cookies, we will not be able to monitor the performance of our website.
        </p>

        <p>
        By accepting our cookies, you agree to our Privacy Policy and Terms and Conditions, where you can find more information about the data we collect and how we use it.
        </p>

        <p>
        You can manage your cookie preferences at any time by adjusting the settings in your browser. Please note that blocking certain types of cookies may impact your experience on the OSTREON website.
        </p>

        <p>
        If you have any questions or concerns about our use of cookies, please contact us at: <a href="mailto:contact@ostreon.io">contact@ostreon.io</a>.
        </p>

        <p className={styles.title}>
          <strong>
            10.2. How long is this data retained?
          </strong>
          <p>
          The information collected through these cookies remains available as long as the cookies are present on the device, without exceeding a duration of thirteen (13) months from their placement.
          </p>
        </p>

        <p className={styles.title}>
          <strong>
            10.3. How to accept or decline cookies?
          </strong>
        </p>

        <p>
        When a User first accesses the Website, a banner appears to provide information about the cookies used and to allow the User to accept or decline the cookies.
        </p>

        <p>
        In any case, Users maintain control over these cookies. They can change or withdraw their consent at any time, via the Website and/or by configuring their browser, with the exception of essential cookies necessary for the Website's operation.
        </p>

        <p>
        Users can also adjust their choices and settings at any time by configuring their browser using the following methods: <a href="https://www.cnil.fr/fr/cookies-et-autres-traceurs/comment-se-proteger/maitriser-votre-navigateur">https://www.cnil.fr/fr/cookies-et-autres-traceurs/comment-se-proteger/maitriser-votre-navigateur</a>.
        </p>

        <p className={styles.title}>
          <strong>
            11. How can you unsubscribe from OSTREON's newsletter?
          </strong>
        </p>

        <p>
        To unsubscribe from OSTREON's newsletter, Users can click on the "Unsubscribe" link located at the bottom of the newsletter to be removed from the distribution list at any time.
        </p>
      </div>
    </>
  );
}